import Swal from 'sweetalert2';
import { RemoteConstants } from '../../data/remote/RemoteConstants';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { errorManager } from '../../presentation/utils/errorManager';
import { pinList } from './pinList';


/* eslint-disable no-unused-vars */
export const updatePinUsuario = async (token, editValues, dispatch) => {
  try {
    const params = new URLSearchParams({
      token: token,
      uid: editValues.uid,
      nombre: editValues.nombre,
      telefono: editValues.telefono,
      email: editValues.email,
      tiene_2fa: editValues.tiene_2fa,
      password: editValues.password
    });
    const peticion = await fetch(`${RemoteConstants.BASE_URL}pin/update?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(resp => {
        return resp.json();
      })
      .then(data => {
        if (data.code === 'OK') {
          Swal.fire('¡Hecho!', data.userMessage, 'success');
          pinList(token, dispatch);
        } else {
          errorManager(data.userMessage);
        }
      });
  } catch (error) {
    errorManager(error);
  }
  dispatch(UIActions.uiLoadInactive());
}